import ContentCopySvg from "../../assets/content_copy.svg";
import BookMarkSvg from "../../assets/bookmark.svg";
import MoreHorizSvg from "../../assets/more_horiz.svg";
import UploadGreySvg from "../../assets/upload_grey.svg";
import AdminIconSvg from "../../assets/images/ActionCard/AdminIcon.svg";
import DashboardIconSvg from "../../assets/sidebar/dashboard_selected.svg";
import clauseCheckSvg from "../../assets/clause_check.svg";
import contractRedliningSvg from "../../assets/contract_redlining.svg";
import talkToContractSvg from "../../assets/talk_to_contract.svg";
import breathingDashboardSvg from "../../assets/breathing_dashboard.svg";
import vmoBotOutlined from "../../assets/vmoBotOutlined.svg";
import keyContractClausesOutlined from "../../assets/keyContractClausesOutlined.svg";
import contractRedliningOutlined from "../../assets/contractRedliningOutlined.svg";
import breathingDashboardOutlined from "../../assets/breathingDashboardOutlined.svg";
import vomRobot from "../../assets/vmoRobot.svg";
import vmoBotSvg from "../../assets/robot.svg";
import vmoBotHoverSvg from "../../assets/robot_highlighted.svg";
import clauseCheckSvgSelected from "../../assets/clause_check_selected.svg";
import clauseCheckSvgUnselected from "../../assets/clause_check_unselected.svg";
import contractRedliningSvgSelected from "../../assets/contract_redlining_selected.svg";
import contractRedliningSvgUnselected from "../../assets/contract_redlining_unselected.svg";
import talkToContractSvgSelected from "../../assets/talk_to_contract_selected.svg";
import talkToContractSvgUnselected from "../../assets/talk_to_contract_unselected.svg";
import breathingDashboardSvgSelected from "../../assets/breathing_dashboard_selected.svg";
import breathingDashboardSvgUnselected from "../../assets/breathing_dashboard_unselected.svg";
import usage_Analytics_svg from "../../assets/usage_Analytics_svg.svg";
import usageAnalyticssvgSelected from "../../assets/usageAnalyticssvgSelected.svg";
import usageAnalyticssvgOutlined from "../../assets/usageAnalyticssvgOutlined.svg";

import { HeaderActionsType, vmoBotType } from "./types";
import { DASHBOARD_ENTITIES, MimeTypes, ROUTES, MODULE_ACCESS } from "../../common/constants";
import { Point } from "./types";

export const headerActionsForContractReview: Array<HeaderActionsType> = [
  // { text: "Upload", img: UploadGreySvg, height: "14px" },
  // { text: "Copy", img: ContentCopySvg, height: "14px" },
  // { text: "Save", img: BookMarkSvg, height: "14px" },
  { text: "ThreeDots", img: MoreHorizSvg, height: "14px", renderOptions: true },
];

export const headerActionsForClauseCheck: Array<HeaderActionsType> = [
  // { text: "Upload", img: UploadGreySvg, height: "14px" },
  { text: "ThreeDots", img: MoreHorizSvg, height: "14px", renderOptions: true },
];

export const GREEN = "green";

export const CONTRACT_REVIEW = "Contract Review";
export const SummaryMetricsType = {
  INTEGER: "integer",
  PERCENT: "percent",
};

export const metDataMapper: any = {
  vertical: "Vertical",
  contract_id: "Contract ID",
  vendor_name: "Vendor Name",
  service_type: "Service Type",
  contract_type: "Contract Type",
  maximum_total_cost: "MTC",
};

export const hideMetaDataForContractReview = [
  "contractId",
  "contract_type",
  "service_type",
  "vendor_name",
  "maximum_billable_hours",
  "start_date",
  "end_date",
  "documentId",
  "simbaId",
];

export const hideMetaDataForClauseCheck = [
  "contractId",
  "contract_type",
  "vendor_name",
  "maximum_total_cost",
  "maximum_billable_hours",
  "start_date",
  "end_date",
  "documentId",
  "simbaId",
];

export const CONTRACTS_REVIEW_PENDING = "Contracts Pending Review";
export const CONTRACT_REVIEW_PENDING_HEADER_DESCP =
  "Contracts currently in queue for automated review.";
export const CONTRACTS_COMPLETE_REVIEW_HEADER_DESCP =
  "Contracts that have finished the automated AI review.";
export const CONTRACTS_COMPLETE_REVIEW = "Contracts Complete Review";
export const CONTRACTS_PENDING_CLAUSE_CHECK = "Contracts Pending Compliance";
export const CONTRACTS_PENDING_CLAUSE_CHECK_HEADER_DESCP =
  "List of bulk-uploaded contracts awaiting clause check.";
export const CONTRACT_COMPLIANCE = "Compliance Clause Checked";
export const CONTRACT_COMPLIANCE_HEADER_DESCP =
  "Total number of contracts reviewed for clause presence and compliance.";
export const recommendationTooltipText =
  "Displays the number of AI generated suggestions per clause.";
export const standardClausesTooltipText =
  "List of contracts where standard clauses are present.";
export const viewAllBtnTooltipTextForContractRedlining =
  "Displays all uploaded contracts including pending and completed AI reviews.";
export const viewAllBtnTooltipTextForClauseCheck =
  "Displays all uploaded contracts including pending and completed AI clause check.";
export const summaryBtnTooltipText =
  "Displays a summary of clause presence for the latest set of contracts uploaded.";

export const defaultSuggestions = [
  { text: "What are the Start and End dates for all the contracts?" },
  { text: "What is the scope of the Supplier's services?" },
  { text: "What is the maximum total cost for each contract?" },
  { text: "What is the minimum Service Level Credit Allocation?" },
];

export const ttcModelTooltips = [
  {
    label: "Gemini 2.5 Pro",
    value:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  {
    label: "Gemini 2.0 Flash",
    value:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
];
export const ttcGeminiModel: any = {
  GEM_1_5_PRO_001: {
    displayName: "Gemini 1.5 Pro - 001",
    name: "gemini-1.5-pro-001",
    toolTipInfo:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  GEM_1_5_PRO_002: {
    displayName: "Gemini 1.5 Pro - 002 (latest)",
    name: "gemini-1.5-pro-002",
    toolTipInfo:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
  GEM_1_5_FLASH_001: {
    displayName: "Gemini 1.5 Flash - 001",
    name: "gemini-1.5-flash-001",
    toolTipInfo:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
  GEM_1_5_FLASH_002: {
    displayName: "Gemini 1.5 Flash - 002 (latest)",
    name: "gemini-1.5-flash-002",
    toolTipInfo:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
  GEMINI_2_0_FLASH_001: {
    displayName: "Gemini 2.0 Flash",
    name: "gemini-2.0-flash-001",
    toolTipInfo:
      "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary.",
  },
  GEMINI_2_5_PRO_05_06: {
    displayName: "Gemini 2.5 Pro",
    name: "gemini-2.5-pro",
    toolTipInfo:
      "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points.",
  },
};
export const defaultStateOfVmoBot: vmoBotType = {
  view: "chat",
  conversationId: "",
  conversationName: "Untitled Conversation",
  chat: [],
  suggestions: defaultSuggestions,
  fileUpload: {
    processingStage: "SelectFiles",
    uploadedFiles: [],
    uploadingState: true,
    processedFiles: {
      [DASHBOARD_ENTITIES.TALK_TO_CONTRACT]: [],
    },
  },
  isMessageLoading: false,
  selectedModel: "gemini-2.0-flash-001",
  selectedFiles: [],
};

export const clauseCheckDocStatus = {
  UPLOAD_IN_PROGRESS: "upload_in_progress",
  UPLOAD_COMPLETED: "upload_completed",
  CLAUSE_CHECK_IN_PROGRESS: "clause_check_in_progress",
  CLAUSE_CHECK_READY: "clause_check_ready_for_review",
  CLAUSE_CHECK_COMPLETED: "clause_check_completed",
  META_DATA_TO_BE_EXTRACTED: "meta_data_to_be_extracted",
  META_EXTRACTION_IN_PROGRESS: "meta_extraction_in_progress",
  META_DATA_EXTRACTED: "meta_extraction_completed",
  FAILED_WHILE_REVIEWING: "failed_while_reviewing",
};

export const bulkClauseApiPropForLatestUpload = {
  clause_status: [
    clauseCheckDocStatus.UPLOAD_IN_PROGRESS,
    clauseCheckDocStatus.UPLOAD_COMPLETED,
    clauseCheckDocStatus.META_EXTRACTION_IN_PROGRESS,
    clauseCheckDocStatus.META_DATA_EXTRACTED,
    clauseCheckDocStatus.CLAUSE_CHECK_IN_PROGRESS,
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
    clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,
  ],
};

export const bulkClauseApiProp = {
  clause_status: [
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
    clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED,

    clauseCheckDocStatus.UPLOAD_IN_PROGRESS,
    clauseCheckDocStatus.UPLOAD_COMPLETED,
    clauseCheckDocStatus.META_EXTRACTION_IN_PROGRESS,
    clauseCheckDocStatus.META_DATA_EXTRACTED,
    clauseCheckDocStatus.CLAUSE_CHECK_IN_PROGRESS,
    clauseCheckDocStatus.CLAUSE_CHECK_READY,
  ],
};

export const uploadStatus = {
  LATEST: "latest",
};

export const actionTypes: any = {
  DASHBOARD: "dashboard",
  ADMIN: "admin",
};

export const actionCards: any = {
  [actionTypes.DASHBOARD]: {
    backgroundImg:
      "https://s3-alpha-sig.figma.com/img/397b/2831/1d31cdd7b433bc882bccbfbee579f9c7?Expires=1728259200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=LttFIYksVFNbq~lYbqUyWRdiW7PH0lgzMvirhy5BebAGyy1rqfszQHN29qhIvhUAte7DyVhJ-LTBSQkP8inprV1CX6c1f76A69wtalzDqFdQCcmlobq2HKNUSxq-yLDvQhvOLLSs6N989a6eSrkss3PzLO-pg72IHa5AAvwrpeHVozenMuXm68EIxaOeV2MOyBGtasuuppxHyHu-moU~uiv9zOPnJK3whKyMFcRHSbcVOI9xCluWjbMkzRh6AyTwTj~Y1GBtl3EPjus9D43WuT5jkHIBbiC50D92QZnHzFNT2PD5mCHegZkfOlf5~D5hgQnV33ttlou7264LSdgPdw__",
    title: "Dashboard",
    subTitle: "Contract management",
    iconImg: DashboardIconSvg,
    imgStyle: {
      height: "28px",
      width: "28px",
    },
    redirectUrl: ROUTES.dashboard,
  },
  [actionTypes.ADMIN]: {
    backgroundImg:
      "https://s3-alpha-sig.figma.com/img/0192/7d4e/7725a7d6874097e28cdecb788ca581fb?Expires=1728259200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=RRjedEcR1LSgBMwrrad1bkettXNeBPeuOZeg6O6LJ9Z3NOVxI6vkl8Nl1teNhlFs2Q5AfbTkQuA~rEqLXIjG08ScxuC09ACIePBWactk-DR9hI78lrDxmo5GavNjJXWz98ACT9I1~KZFlSdHd99PXXQohP0iG5oqbS1LxDYp-zUkq9Rw4npLXMmQ92QryqEgVbRPiytZqdu6ptEk4toQ2HllbveQLCSP9YiHzlQpIQgtVL~UeRFt~v1JokjvVhNrx3QcEKVsxmOHh11MLhSJ~yMODRc5kMgCRgewxABSknNWgcQ5QxBsxIUuvtcuZAcxO35TE4vwUQ8~vOMG6XQbEQ__",
    title: "Manage",
    subTitle: "Manage users and clauses",
    iconImg: AdminIconSvg,
    imgStyle: {
      height: "28px",
      width: "28px",
    },
    redirectUrl: ROUTES.adminDashboard,
  },
};

export const VMO_BOT_MIN_MSG_LENGTH = 5;

export const MIN_MSG_ERROR = `The input message seems a bit too short. Please provide more than ${VMO_BOT_MIN_MSG_LENGTH} alphabetic characters.`;
export const VMO_BOT_FILE_UPLOAD_LIMIT = 5;

export const LANDING_PAGE_TO_DASHBOARD_URLS = {
  ttc: "ttc",
  clause_check: "clause_check",
  clause_check_advanced: "clause_check_advanced",
  clause_check_agentic: "clause_check_agentic",
  contract_redlining: "contract_review",
  breathing_dashboard: "breathing_dashboard",
  ttc_agentic: "ttc_agentic",
  usage_analytics: "usage_analytics",
  contract_draft_requests: "contract_draft_requests",
  contract_execution: "contract_execution",
};

export const DASHBOARD_FEATURES = {
  TALK_TO_CONTRACT: "Talk to Contract ",
  CLAUSE_CHECK: "Key Contract Clauses ",
  CLAUSE_CHECK_ADVANCED: "Key Contract Clauses - Advanced",
  CONTRACT_EXECUTION: "Contract Repository",
  TALK_TO_CONTRACT_AGENTIC: "Talk to Contract",
  CLAUSE_CHECK_AGENTIC: "Key Contract Clauses",
  BREATHING_DASHBOARD: "Breathing Dashboard",
  CONTRACT_DRAFT_DASHBOARD: "Contract Drafting",
  CONTRACT_REDLINING: "Contract Review",
  USAGE_ANALYTICS: "Usage Analytics",
};

export const DASHBOARD_TABS = {
  [LANDING_PAGE_TO_DASHBOARD_URLS.ttc_agentic]: {
    tab: DASHBOARD_FEATURES.TALK_TO_CONTRACT,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.clause_check]: {
    tab: DASHBOARD_FEATURES.CLAUSE_CHECK,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining]: {
    tab: DASHBOARD_FEATURES.CONTRACT_REDLINING,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.breathing_dashboard]: {
    tab: DASHBOARD_FEATURES.BREATHING_DASHBOARD,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.usage_analytics]: {
    tab: DASHBOARD_FEATURES.USAGE_ANALYTICS,
  },
  [LANDING_PAGE_TO_DASHBOARD_URLS.contract_execution]: {
    tab: DASHBOARD_FEATURES.CONTRACT_EXECUTION,
  },
};

export const dashboardConfig = {
  [DASHBOARD_FEATURES.CONTRACT_REDLINING]: {
    mainIcon: contractRedliningOutlined,
    headerText: DASHBOARD_FEATURES.CONTRACT_REDLINING,
    moduleName: MODULE_ACCESS.CONTRACT_REVIEW,
    description:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster contract negotiations and execution.",
    points: [
      {
        number: 23,
        description: "Uploaded Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
      {
        number: 7,
        description: "Pending Review",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "pending",
      },
      {
        number: 12,
        description: "Completed Review",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "completed",
      },
    ] as Point[],
    hoverText:
      "Review contracts through AI-powered redlining, markup and edit suggestions for faster negotiations and execution.",
    icon: {
      selected: contractRedliningSvgSelected,
      unselected: contractRedliningSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.contract_redlining,
  },
  [DASHBOARD_FEATURES.CLAUSE_CHECK]: {
    mainIcon: keyContractClausesOutlined,
    headerText: DASHBOARD_FEATURES.CLAUSE_CHECK,
    isLive: false,
    description:
      "Bulk check to detect missing or non-standard compliance clauses.",
    points: [
      {
        number: 23,
        description: "Uploaded Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
      {
        number: 7,
        description: "Contracts Pending",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "pending",
      },
      {
        number: 12,
        description: "Clause Checked",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "completed",
      },
    ] as Point[],
    hoverText:
      "Bulk check to detect missing or non-standard compliance clauses.",
    icon: {
      selected: clauseCheckSvgSelected,
      unselected: clauseCheckSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.clause_check,
  },
  [DASHBOARD_FEATURES.CLAUSE_CHECK_ADVANCED]: {
    mainIcon: keyContractClausesOutlined,
    headerText: DASHBOARD_FEATURES.CLAUSE_CHECK_ADVANCED,
    isLive: false,
    description:
      "Advanced bulk check to detect missing or non-standard compliance clauses.",
    points: [
      {
        number: 23,
        description: "Uploaded Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
      {
        number: 7,
        description: "Contracts Pending",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "pending",
      },
      {
        number: 12,
        description: "Clause Checked",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "completed",
      },
    ] as Point[],
    hoverText:
      "Bulk check to detect missing or non-standard compliance clauses.",
    icon: {
      selected: clauseCheckSvgSelected,
      unselected: clauseCheckSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.clause_check_advanced,
  },
  [DASHBOARD_FEATURES.CLAUSE_CHECK_AGENTIC]: {
    mainIcon: keyContractClausesOutlined,
    headerText: DASHBOARD_FEATURES.CLAUSE_CHECK_AGENTIC,
    moduleName: MODULE_ACCESS.CLAUSE_CHECK,
    isLive: false,
    description:
      "Agentic engine for intelligent contract insights with targeted vertical analysis.",
    points: [
      {
        number: 0,
        description: "Total Files",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total",
      },
    ] as Point[],
    hoverText:
      "Agentic engine for intelligent contract insights with targeted vertical analysis.",
    icon: {
      selected: clauseCheckSvgSelected,
      unselected: clauseCheckSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.clause_check_agentic,
  },
  [DASHBOARD_FEATURES.TALK_TO_CONTRACT]: {
    mainIcon: vmoBotOutlined,
    headerText: DASHBOARD_FEATURES.TALK_TO_CONTRACT,
    description:
      "Extract key insights and answers from single or multiple uploaded contracts.",
    lightIcon: vmoBotHoverSvg,
    hoverText:
      "Engage directly with your documents. Get instant, AI-powered responses for questions on contract.",
    icon: {
      selected: talkToContractSvgSelected,
      unselected: talkToContractSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.ttc,
    isLive: true,
    enableUploadButton: true,
  },
  [DASHBOARD_FEATURES.TALK_TO_CONTRACT_AGENTIC]: {
    mainIcon: vmoBotOutlined,
    headerText: DASHBOARD_FEATURES.TALK_TO_CONTRACT_AGENTIC,
    moduleName: MODULE_ACCESS.TALK_TO_CONTRACT,
    description:
      "This agentic engine enables users to ask questions tailored to their selected vertical, providing targeted and intelligent contract insights.",
    lightIcon: vmoBotHoverSvg,
    hoverText:
      "Engage directly with your documents. Get instant, AI-powered responses for questions on contract.",
    icon: {
      selected: talkToContractSvgSelected,
      unselected: talkToContractSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.ttc_agentic,
    isLive: false,
  },
  [DASHBOARD_FEATURES.BREATHING_DASHBOARD]: {
    mainIcon: breathingDashboardOutlined,
    headerText: DASHBOARD_FEATURES.BREATHING_DASHBOARD,
    moduleName: MODULE_ACCESS.BREATHING_DASHBOARD,
    points: [
      {
        number: 0,
        description: "Expiring in 0-30 Days",
        backgroundColor: "#E03C2F0D",
        color: "#E03C2F",
        border: "1px solid #E03C2F",
        countKey: "expiring_in_30_days",
      },
      {
        number: 0,
        description: "Expiring in 31-60 Days",
        backgroundColor: "#E6A8000D",
        color: "#E6A800",
        border: "1px solid #E6A800",
        countKey: "expiring_in_60_days",
      },
      {
        number: 0,
        description: "Expiring in 61-90 Days",
        backgroundColor: "#545FE81A",
        color: "#545FE8",
        border: "1px solid #545FE8",
        countKey: "expiring_in_90_days",
      },
    ] as Point[],
    hoverText: [
      "A real-time overview of all active contracts and their upcoming expiration dates.",
      "Monitor which contracts are nearing their end date.",
    ],
    icon: {
      selected: breathingDashboardSvgSelected,
      unselected: breathingDashboardSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.breathing_dashboard,
  },
  [DASHBOARD_FEATURES.USAGE_ANALYTICS]: {
    mainIcon: usageAnalyticssvgOutlined,
    headerText: DASHBOARD_FEATURES.USAGE_ANALYTICS,
    points: [
      {
        number: 0,
        description: "Unique Users Metrics",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "Unique Users Metrics",
      },
      {
        number: 0,
        description: "Module Visits Breakdown",
        backgroundColor: "#E6A8000D",
        color: "#F57C00",
        border: "1px solid #E6A800",
        countKey: "Module Visits Breakdown",
      },
      {
        number: 0,
        description: "Login History",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "Login History",
      },
    ] as Point[],
    hoverText: [
      "Monitor user activity and system usage metrics across the Orbit application.",
      "View analytics on unique users metrics, module visits, and login history.",
    ],
    icon: {
      selected: usageAnalyticssvgSelected,
      unselected: usage_Analytics_svg,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.usage_analytics,
  },
  [DASHBOARD_FEATURES.CONTRACT_DRAFT_DASHBOARD]: {
    mainIcon: contractRedliningOutlined,
    headerText: DASHBOARD_FEATURES.CONTRACT_DRAFT_DASHBOARD,
    moduleName: MODULE_ACCESS.CONTRACT_DRAFTING,
    isLive: false,
    description:
      "Track and manage contract drafting requests from initiation to completion.",
    points: [
      {
        number: 0,
        description: "New Requests",
        className: "new-requests-icon",
        backgroundColor: "#E8F0FE",
        color: "#1967D2",
        border: "1px solid #1967D2",
        countKey: "NEW",
      },
      {
        number: 0,
        description: "Ready for Drafting",
        className: "in-progress-icon",
        backgroundColor: "#FEF7E0",
        color: "#E37400",
        border: "1px solid #E37400",
        countKey: "READY_FOR_DRAFTING",
      },
      {
        number: 0,
        description: "Draft Generated",
        className: "review-icon",
        backgroundColor: "#F3E8FD",
        color: "#681DA8",
        border: "1px solid #681DA8",
        countKey: "DRAFT_GENERATED",
      },
      {
        number: 0,
        description: "Reviewed",
        className: "reviewed-icon",
        backgroundColor: "#E0F2F1",
        color: "#0D652D",
        border: "1px solid #0D652D",
        countKey: "REVIEWED",
      },
      {
        number: 0,
        description: "Completed",
        className: "complete-icon",
        backgroundColor: "#E6F4EA",
        color: "#137333",
        border: "1px solid #137333",
        countKey: "COMPLETED",
      },
    ] as Point[],
    hoverText:
      "Centralized dashboard for tracking contract drafting workflows with real-time updates.",
    icon: {
      selected: contractRedliningSvgSelected,
      unselected: contractRedliningSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.contract_draft_requests,
  },
  [DASHBOARD_FEATURES.CONTRACT_EXECUTION]: {
    mainIcon: breathingDashboardOutlined,
    headerText: DASHBOARD_FEATURES.CONTRACT_EXECUTION,
    moduleName: MODULE_ACCESS.CONTRACT_REPOSITORY,
    points: [
      {
        number: 0,
        description: "Total Contracts",
        backgroundColor: "#3474E00D",
        color: "#3474E0",
        border: "1px solid #1E88E5",
        countKey: "total_contracts",
      },
      {
        number: 0,
        description: "Active Contracts",
        backgroundColor: "#0E9D580D",
        color: "#00796B",
        border: "1px solid #0E9D58",
        countKey: "active_contracts",
      },
      {
        number: 0,
        description: "Pending Contracts",
        backgroundColor: "#E6A8000D",
        color: "#E6A800",
        border: "1px solid #E6A800",
        countKey: "pending_contracts",
      },
    ] as Point[],
    hoverText: [
      "Comprehensive view of contract execution lifecycle and status tracking.",
    ],
    icon: {
      selected: breathingDashboardSvgSelected,
      unselected: breathingDashboardSvgUnselected,
    },
    featureUrl: LANDING_PAGE_TO_DASHBOARD_URLS.contract_execution,
  },
};

export const actionType = {
  UPLOAD: "upload",
  HOME_STORAGE: "homeStorage",
};

export const CLAUSE_CHECK = DASHBOARD_FEATURES.CLAUSE_CHECK;

export const key_contract_clauses_columns = [
  { field: "vendor_name", headerName: "Vendor" },
  { field: "display_name", headerName: "Contract Name" },
  { field: "vertical", headerName: "Vertical" },
  { field: "maximum_total_cost", headerName: "MTC" },
  { field: "service_type", headerName: "Service Type" },
  { field: "status", headerName: "Status" },
];

export const redliningColumns = [
  { field: "vendor_name", headerName: "Vendor" },
  { field: "display_name", headerName: "Contract Name", clickable: true },
  { field: "vertical", headerName: "Vertical" },
  { field: "maximum_total_cost", headerName: "MTC" },
];

export const recommendationsColors = [
  "#3B00ED",
  "#4285F4",
  "#43A047",
  "#C0CA33",
  "#FF9800",
  "#FFC107",
];

export const DATE_FORMAT = "MM-DD-YYYY";

export const DAYS = {
  THIRTY: 30,
  SIXTY: 60,
  NINETY: 90,
  CUSTOM: -1,
};

export const getExtensionFromFileName = (fileName: string): string => {
  const parts = fileName.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
};

export const getMimeTypeAsPerFileExtension = (fileName: string): string => {
  const extension = getExtensionFromFileName(fileName);
  switch (extension) {
    case "pdf":
      return MimeTypes.pdf;
    case "doc":
    case "docx":
      return MimeTypes.docx;
    case "ppt":
      return MimeTypes.ppt;
    case "pptx":
      return MimeTypes.pptx;
    case "xls":
    case "xlsx":
      return MimeTypes.xlsx;
    case "txt":
      return MimeTypes.txt;
    case "csv":
      return MimeTypes.csv;
    default:
      return "application/octet-stream";
  }
};

export const dummyFilesDataForRag = {
  status: "success",
  corpus_id: "2842897264777625600",
  files: [
    {
      id: "5539031449282212483",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449282212483",
      display_name: "DELOITTE CONSUL-SOW-GP-10000063.pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.709946+00:00",
      update_time: "2025-10-07 05:40:31.709946+00:00",
    },
    {
      id: "5539031449737322702",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449737322702",
      display_name: "DELOITTE CONSUL-AMD-GP-40001141-1 (1).pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.742088+00:00",
      update_time: "2025-10-07 05:40:31.742088+00:00",
    },
    {
      id: "5539031449282212483",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449282212483",
      display_name: "DELOITTE CONSUL-SOW-GP-10000063.pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.709946+00:00",
      update_time: "2025-10-07 05:40:31.709946+00:00",
    },
    {
      id: "5539031449737322702",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449737322702",
      display_name: "DELOITTE CONSUL-AMD-GP-40001141-1 (1).pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.742088+00:00",
      update_time: "2025-10-07 05:40:31.742088+00:00",
    },
    {
      id: "5539031449282212483",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449282212483",
      display_name: "DELOITTE CONSUL-SOW-GP-10000063.pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.709946+00:00",
      update_time: "2025-10-07 05:40:31.709946+00:00",
    },
    {
      id: "5539031449737322702",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449737322702",
      display_name: "DELOITTE CONSUL-AMD-GP-40001141-1 (1).pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.742088+00:00",
      update_time: "2025-10-07 05:40:31.742088+00:00",
    },
    {
      id: "5539031449282212483",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449282212483",
      display_name: "DELOITTE CONSUL-SOW-GP-10000063.pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.709946+00:00",
      update_time: "2025-10-07 05:40:31.709946+00:00",
    },
    {
      id: "5539031449737322702",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449737322702",
      display_name: "DELOITTE CONSUL-AMD-GP-40001141-1 (1).pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.742088+00:00",
      update_time: "2025-10-07 05:40:31.742088+00:00",
    },
    {
      id: "5539031449282212483",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449282212483",
      display_name: "DELOITTE CONSUL-SOW-GP-10000063.pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.709946+00:00",
      update_time: "2025-10-07 05:40:31.709946+00:00",
    },
    {
      id: "5539031449737322702",
      name: "projects/723496803942/locations/us-east4/ragCorpora/2842897264777625600/ragFiles/5539031449737322702",
      display_name: "DELOITTE CONSUL-AMD-GP-40001141-1 (1).pdf",
      description: "",
      source_uri: null,
      create_time: "2025-10-07 05:40:31.742088+00:00",
      update_time: "2025-10-07 05:40:31.742088+00:00",
    },
  ],
  count: 23,
  next_page_token: "",
  message: "Found 2 file(s) in corpus '2842897264777625600'",
};

// Maps raw currency strings (from extraction) → ISO code
export const CURRENCY_NORMALIZE: Record<string, string> = {
  // USD variants
  'usd': 'USD', '$': 'USD', 'us$': 'USD',
  'us dollars': 'USD', 'u.s. dollars': 'USD',
  // EUR variants
  'eur': 'EUR', '€': 'EUR', 'euro': 'EUR',
  // JPY variants
  'jpy': 'JPY', '¥': 'JPY',
  // BRL variants
  'brl': 'BRL', 'r$': 'BRL', 'brazilian real': 'BRL',
  // MYR variants
  'myr': 'MYR', 'rm': 'MYR',
  // ILS variants
  'ils': 'ILS', '₪': 'ILS',
  // Clean ISO codes (pass-through)
  'cad': 'CAD', 'gbp': 'GBP', 'aud': 'AUD', 'chf': 'CHF',
  'inr': 'INR', 'sgd': 'SGD', 'cny': 'CNY', 'vnd': 'VND',
  'krw': 'KRW', 'idr': 'IDR', 'php': 'PHP', 'sek': 'SEK',
  'ars': 'ARS', 'thb': 'THB',
};

// Maps ISO code → locale for Intl.NumberFormat
export const CURRENCY_LOCALE: Record<string, string> = {
  USD: 'en-US', CAD: 'en-CA', GBP: 'en-GB', EUR: 'en-DE',
  INR: 'en-IN', JPY: 'ja-JP', AUD: 'en-AU', SGD: 'en-SG',
  CHF: 'de-CH', CNY: 'zh-CN', VND: 'vi-VN', BRL: 'pt-BR',
  ILS: 'he-IL', KRW: 'ko-KR', IDR: 'id-ID', PHP: 'en-PH',
  SEK: 'sv-SE', ARS: 'es-AR', MYR: 'ms-MY', THB: 'th-TH',
};
